import React from "react";
import { MdArrowBack } from "react-icons/md";
import "./Sidebar.css";
import { constants } from "../../constants";
import { Link } from "react-router-dom";
import classNames from "classnames";

const SidebarOptions = ({ visible, setVisible, selected }) => {
  return (
    <div
      className={classNames({
        "option-menu shadow-lg md:h-screen space-y-4": visible === true,
        "option-menu-hidden": visible === false,
      })}
    >
      {visible && (
        <>
          <div className="flex pt-6 px-8">
            <button
              className="outline-none  mr-4"
              onClick={() => setVisible((val) => !val)}
            >
              <MdArrowBack className="" size={24} />
            </button>

            <div>
              <h3 className="text-base uppercase">{selected}</h3>
            </div>
          </div>
          {/* Iterate Over Available Options */}
          <div className="">
            {constants.sidebarMenu[selected].children.map((children) => (
              <Link
                key={children.url}
                className="block font-medium hover:bg-gray-200"
                to={children.url}
              >
                <p className="py-4 px-8">{children.name}</p>
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SidebarOptions;
